import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>How will your business grow with <span>React Native</span> Mobile App Development?</h2>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                       <p>Mobile apps are expected to generate $935 billion in 2023 and in the upcoming years, and they are further anticipated to grow and touch the trillion-dollar mark.</p>
                       <p>React Native offers a strategic choice for businesses and startups to grow by improving productivity and transforming their work overnight, achieving all this by decreasing costs. Here's an in-depth study of convincing reasons to choose React Native for mobile app development, securing a discrete advantage over your competitors:</p>
                    </Col>
                </Row>
                <Row className="h-100 buss-padd">
                <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                    <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Cross-Platform Proficiency</h6>
                            <p>Influence a wider audience with a single codebase for both iOS and Android, decreasing development time and costs.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Prompt Time-to-Market</h6>
                            <p>React Native's recyclable components, and hot-reloading feature hasten development, guaranteeing faster product launches.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Cost-Efficiency</h6>
                            <p>Save your resources by hiring a seamless development team and shared codebase for several platforms, enhancing cost-effectiveness.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Near-Native Performance</h6>
                            <p>Provide an approachable user experience with React Native's capability to compile to native code, guaranteeing high performance similar to native apps.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Dynamic Landscape</h6>
                            <p>Tap into a vast collection of pre-built components, plugins, and a helpful community, hastening development and problem-solving.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Flawless Updates & Maintenance</h6>
                            <p>Apply updates impeccably across platforms and modernize maintenance with React Native's flexible and intuitive structure, guaranteeing long-term scalability.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Androidbuss